import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@app/core/services/base-http.service';
import { CountryListItem } from '../models/common.model';
import { CacheService } from './cache.service';

@Injectable({
  providedIn: 'root'
})
export class CountryService extends BaseHttpService {
  private _cacheService = inject(CacheService);

  getAllCountries(): Observable<CountryListItem[]> {
    return this._cacheService.cacheObservable(
      '/api/country',
      this.httpClient.get<CountryListItem[]>(`${this.baseApiUrl}/api/country`)
    );
  }
}
